import { render, staticRenderFns } from "./Flows.vue?vue&type=template&id=6fa58406"
import script from "./Flows.vue?vue&type=script&lang=js"
export * from "./Flows.vue?vue&type=script&lang=js"
import style0 from "./Flows.vue?vue&type=style&index=0&id=6fa58406&prod&lang=less"
import style1 from "./Flows.vue?vue&type=style&index=1&id=6fa58406&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports